<template>
  <div class="dlnkdocs_component w-100">

    <dlnkwait :wait_data="wait_data"></dlnkwait>

    <div v-if="message" id="alert_message" class="alert alert-dismissible alert-modal" role="alert"
         :class="message_type">
      <button type="button" class="close" aria-label="Close" @click="close_message()">
        <span aria-hidden="true">&times;</span>
      </button>
      <span v-html="message"></span>
    </div>
    <dlnkdocs-form
        :document="document"
        :sections="sections"
        :menus="menus"
        :group_id="group_id"
        @get_data="get_data">
    </dlnkdocs-form>

    <div class="clearfix"></div>

    <!-- Filter -->
    <div id="sortByTheme" class="mb-3">
      <span class="text">Catégories :</span>

      <a class="badge badge-soft-primary text-left mb-2 active"
         href="javascript:" id="section-0"
         @click="toggle_section(0)">
        Toutes
      </a>

      <a class="badge badge-soft-primary text-left mx-1 mb-2"
         :id="'section-' + section.id"
         href="javascript:"
         v-for="section in used_sections"
         :key="section.id"
         @click="toggle_section(section.id)">
        {{section.section}}
      </a>

    </div>

    <div class="row mb-3">
      <div class="col-4">
          <button v-if="!!admin || member_status == 0"
                  type="button" class="btn btn-primary float-right ml-1" @click="add_document()">
            <i class="fa fa-plus" aria-hidden="true"></i> &nbsp;Ajouter
          </button>
      </div>
      <div class="col-4">
        <div class="d-flex align-items-center justify-content-center justify-content-md-end text-center text-sm-left">
          <div class="dropdown dropleft">
            <button id='dropdown-sort' class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-filter mr-2"></i>Trier par
            </button>
            <div class="dropdown-menu dropdown-sort">
              <a class="dropdown-item" href="javascript:" v-on:click="sort('position', 'asc')">
                Position
              </a>
              <a class="dropdown-item" href="javascript:" v-on:click="sort('created_at', 'desc')">
                Date d'ajout (plus récents)
              </a>
              <a class="dropdown-item" href="javascript:" v-on:click="sort('created_at', 'asc')">
                Date d'ajout (plus anciens)
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- SEARCH -->
      <div class="col-4">
        <input v-on:keyup="search_documents" type="text" placeholder="Rechercher ..." class="form-control-sm w-100 border" v-model="search">
      </div>
      <!-- END SEARCH -->

    </div>

    <div class="row">
      <dlnkdocs-document
          v-for="document in documents"
          :key="document.id"
          :document="document"
          :category="Number(category)"
          :admin="admin"
          @edit_document="edit_document($event)"
          @delete_document="delete_document($event)"
          @document_down="document_down($event)"
          @document_up="document_up($event)"
      ></dlnkdocs-document>
    </div>

  </div>
</template>

<script>

export default {
  props: ['group_id', 'type_id'],
  data: function () {
    return {
      document: Object,
      sections: [],
      used_sections: [],
      documents: [],
      menus: [],
      used_themes: [],
      videos: [],
      search: '',
      sort_column: 'id',
      sort_direction: 'desc',
      category: 0,
      master_company: false,
      document_id: 0,
      section_id: 0,
      kind: 'file',
      video_url: '',
      is_community: false,
      admin: false,
      member_status: 2,
      message: '',
      messsage_type: '',
      method: 'post',
      wait_data: Boolean,
    }
  },
  mounted() {
    this.wait_data = true
    this.get_data()
  },

  computed: {
    submit_disabled: function () {
      return false;
    }
  },

  methods: {

    close_message: function () {
      this.message = null;
    },

    edit_document: function(document) {
      this.document = document
      $('#document_modal').modal('show');
    },

    add_document: function() {
      this.document = {}
      $('#document_modal').modal('show');
    },

    get_data: function () {
      this.get_documents()
      this.get_sections()
      this.get_menus()
    },

    delete_document: function(document_id) {
      const _this = this
      this.wait_data = true

      get_token_2().then(function (response) {
        let group = ''
        let [secure_key, customer_id, api_url, customer] = response
        api_url += `documents/${document_id}.json`
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios.delete(api_url)
            .then(function (response) {
              _this.get_data()
              _this.message = "Document correctement supprimé.";
              _this.message_type = "alert-success"
            })
            .catch(function (error) {
              console.log(error)
            })
            .then(function () {
                  // always executed
                }
            );
      })
    },

    document_down: function(document_id) {
      const _this = this;
      const url = '/modules/dlnkdocs/actions/documents.php';
      const form_data = new FormData();
      form_data.append('method', 'down');
      form_data.append('document_id', document_id);

      axios({
        method: 'post',
        url: url,
        data: form_data,
        headers: {'Content-Type': 'multipart/form-data' }
      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if(status) {
              _this.get_documents();
              _this.message = "Position modifiée.";
              _this.message_type = "alert-success"
            } else {
              _this.errors = response.data.errors;
            }
          })
          .catch(function (response) {
            //handle error
          });
    },

    document_up: function(document_id) {
      const _this = this;
      const url = '/modules/dlnkdocs/actions/documents.php';
      const form_data = new FormData();
      form_data.append('method', 'up');
      form_data.append('document_id', document_id);

      axios({
        method: 'post',
        url: url,
        data: form_data,
        headers: {'Content-Type': 'multipart/form-data' }
      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if(status) {
              _this.get_documents();
              _this.message = "Position modifiée.";
              _this.message_type = "alert-success"
            } else {
              _this.errors = response.data.errors;
            }
          })
          .catch(function (response) {
            //handle error
          });
    },

    get_sections: function () {
      const _this = this
      get_token_2().then(function (response) {
        let group = ''
        let [secure_key, customer_id, api_url, customer] = response
        api_url += "document_sections.json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        if (typeof _this.group_id !== 'undefined') {
          api_url += '&group_id=' + _this.group_id
        }

        axios.get(api_url)
            .then(function (response) {
              _this.sections = response.data.sections
              _this.used_sections = response.data.used_sections
            })
            .catch(function (error) {
              console.log(error)
            })
            .then(function () {
                  // always executed
                }
            );
      })
    },

    get_menus: function () {
      const _this = this
      get_token_2().then(function (response) {
        let [secure_key, customer_id, api_url, customer] = response
        api_url += "document_types.json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id

        axios.get(api_url)
            .then(function (response) {
              _this.menus = response.data.types
            })
            .catch(function (error) {
              console.log(error)
            })
            .then(function () {
                  // always executed
                }
            );
      })
    },

    get_documents: function () {
      const _this = this
      get_token_2().then(function (response) {
        let group = ''
        let [secure_key, customer_id, api_url, customer] = response
        api_url += "documents.json"
        api_url += '?secure_key=' + secure_key
        api_url += '&customer_id=' + customer_id
        api_url += '&type_id=' + _this.type_id
        api_url += '&search=' + _this.search
        api_url += '&sort_column=' + _this.sort_column
        api_url += '&sort_direction=' + _this.sort_direction

        if (typeof _this.group_id !== 'undefined') {
          api_url += '&group_id=' + _this.group_id
        }

        axios.get(api_url)
            .then(function (response) {
              _this.documents = response.data.documents
              _this.master_company = response.data.master_company
              _this.admin = response.data.meta.admin
              _this.member_status = response.data.member_status
            })
            .catch(function (error) {
              console.log(error)
            })
            .then(function () {
              _this.wait_data = false
            });
      })
    },

    toggle_section: function (section_id) {
      this.category = section_id;

      $('#sortByTheme').children().removeClass('active');
      $('#sortByTheme').children( '#section-' + section_id ).addClass('active');
    },

    sort: function (sort_column, sort_direction) {
      this.sort_column = sort_column;
      this.sort_direction = sort_direction;
      this.get_documents();
      $('#dropdown-sort').dropdown('toggle');
    },

    search_documents() {
      this.get_documents();
    }
  },
}
</script>
